import { ReactChild } from 'react';

export interface PaletteTool {
    id: string;
    label: ReactChild;
    children?: ReactChild;
}

export enum PALETTE_ORIENTATION {
    VERTICAL = 'vertical',
    VERTICAL_RIGHT = 'vertical_right',
    HORIZONTAL = 'horizontal',
}
